import cn from 'classnames';
import React, {ReactNode, FC} from 'react';
import './widget-wrapper.less';

interface IWidgetWrapperProps {
    title?: string;
    children?: ReactNode;
    className?: string | cn.ArgumentArray;
}

export const WidgetWrapper: FC<IWidgetWrapperProps> = ({children, title, className}: IWidgetWrapperProps) => (
    <div className={cn('widget-wrapper', className)}>
        {title && <div className={cn('widget-title')}>{title}</div>}
        {children}
    </div>
);
